const translations = {
  "en": {
    "Add": "Add",
    "Cancel": "Cancel",
    "The institution is already connected": "The institution is already connected"
  },
  "zh-tw": {
    "Add": "新增",
    "Cancel": "取消",
    "The institution is already connected": "該機構已連結"
  }
};

export default translations;
